import { render } from "./PaymentRequest.vue?vue&type=template&id=595ef290&scoped=true"
import script from "./PaymentRequest.vue?vue&type=script&lang=js"
export * from "./PaymentRequest.vue?vue&type=script&lang=js"

import "./PaymentRequest.vue?vue&type=style&index=0&id=595ef290&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595ef290"]])

export default __exports__